import { render, staticRenderFns } from "./RecordingSkeleton.vue?vue&type=template&id=363bf563&scoped=true"
var script = {}
import style0 from "./RecordingSkeleton.vue?vue&type=style&index=0&id=363bf563&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363bf563",
  null
  
)

export default component.exports